import { connect } from 'react-redux';

import { backToQueryHandler } from '../BreadcrumbsActions';
import { isBackToQueryVisible, isBackToQueryBuilder, breadcrumbById } from '../BreadcrumbsSelectors';
import BackToQueryBreadcrumbs from './BackToQueryBreadcrumbs';

function mapStateToProps(state, ownProps) {
  return {
    breadcrumb: breadcrumbById(state, ownProps),
    isBackToQueryVisible: isBackToQueryVisible(state, ownProps),
    isBackToQueryBuilder: isBackToQueryBuilder(state, ownProps),
  };
}

const mapDispatchToProps = {
  backToQueryHandler,
};

export default connect(mapStateToProps, mapDispatchToProps)(BackToQueryBreadcrumbs);
